import { DresonRuleResolvedEvent } from "../../types/FilterTypes";
import { eventQBus } from "../../types/EventQBus";

export default class LoadBottomLinks {
  static onLoadBottomLinks(data: DresonRuleResolvedEvent): void {
    const bottomLinksNode: HTMLElement | null =
      document.getElementById("reptile-bottom-links") || document.getElementById("san_bottomLinks");
    if (!bottomLinksNode) {
      return;
    }

    const { rule } = bottomLinksNode.dataset;
    if (rule === data.rule) {
      return;
    }

    fetch(LoadBottomLinks.uri(data.rule))
      .then(LoadBottomLinks.extractResponseText)
      .then((html: string) => LoadBottomLinks.replaceBottomLinks(bottomLinksNode, data.rule, html))
      .then(LoadBottomLinks.emitBottomLinksLoaded)
      .catch((e: Error) => {
        console.warn(`Filter reload AJAX GET against ${LoadBottomLinks.uri(data.rule)} failed: ${e.message}`);
      });
  }

  private static extractResponseText(xhr: Response) {
    if (xhr.status !== 200 && xhr.status !== 204) {
      throw Error(`Failed to retrieve bottom links: ${xhr.status} ${xhr.statusText}`);
    }
    return xhr.text();
  }

  /**
 *
 *
 *
 *
 *
 *
 *
 *
 */
  private static replaceBottomLinks(bottomLinksNode: HTMLElement, rule: string, html: string) {
    /*                                 */
    const range = document.createRange();
    range.selectNodeContents(bottomLinksNode);

    /*                                                               */
    const fragment = range.createContextualFragment(html);

    /*           */
    range.deleteContents();
    range.insertNode(fragment);

    /*                     */
    bottomLinksNode.dataset.rule = rule;

    /*                                                                     */
    window.preload_polyfill_invoke(bottomLinksNode);
  }

  private static uri(ruleString: string) {
    return `/scp-bob/page/${ruleString}/bottom-links.html`;
  }

  private static emitBottomLinksLoaded() {
    eventQBus.emit("reptile.bottomLinks.loaded");
  }
}
